import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceReaxysInformation from '@Components/Results/substances/information/SubstanceReaxysInformation';

// eslint-disable-next-line react/display-name
const SubstanceInformation = React.memo(({ metadata, substance, database, facts, zoom, onCloseFact }) => {
  const { index: substanceIndex, details } = substance;

  return (
    <div id={`substances-${substanceIndex}`} className="substance-results-information u-els-font-size-base u-els-line-height-default">
      <SubstanceReaxysInformation
        metadata={metadata}
        facts={facts}
        details={details}
        database={database}
        substanceIndex={substanceIndex}
        zoom={zoom}
        substance={substance}
        onCloseFact={onCloseFact}
      />
    </div>
  );
});

SubstanceInformation.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  facts: PropTypes.object.isRequired,
  onCloseFact: PropTypes.func.isRequired,
  zoom: PropTypes.number,
};

export default SubstanceInformation;
